<template>
    <header>
        <div class="app-bar">
            <div class="logo-wrap">
                <!--<img src="@/assets/img/logo.png" alt="" v-show="logoView">-->
            </div>
            <div class="share-bar">
                <span class="text">
                    SHARE
                </span>
                <a class="share tw" target="_blank" :href="'http://twitter.com/intent/tweet?text=' + text + '&amp;url=' + url ">
                    <Tw />
                </a>
                <a href="https://www.facebook.com/share.php?u=https%3A%2F%2Fgintonic.jp%2Fbombay-foodpairing%2F" target="_blank" class="share fb">
                    <Fb />
                </a>
            </div>
        </div>
        <!--<div class="btn-bar hidePc" v-if="OnOff">
            <a class="btn curry" v-if="status[0]" v-scroll-to="'#curry'">
                ビーフキーマカレー
            </a>
            <a class="btn maho" v-if="status[1]" v-scroll-to="'#maho'">
                四川麻婆豆腐
            </a>
            <a class="btn nabe" v-if="status[2]" v-scroll-to="'#nabe'">
                ガラムマサラチゲ鍋
            </a>
        </div>-->
    </header>
</template>

<script>
import Fb from "@/assets/img/icon_fb.svg?inline"
import Tw from "@/assets/img/icon_tw.svg?inline"

export default {
    props:{
        OnOff: Boolean,
        status: Array
    },
    components:{
        Fb,
        Tw
    },
    data(){
        return{
            url: 'https://gintonic.jp/bombay-foodpairing/',
            text: 'スパイス料理とジントニック。その相性のよさは科学的にも証明されています。ここではボンベイ・サファイアにマッチするスパイス料理のオリジナルレシピをご紹介。ちょい足しするだけで美味しさが増す、今晩にでもすぐ試せる簡単アレンジ料理です。'
        }
    },
    created(){
        
    }
}
</script>

<style lang="scss" scoped>
header{
    width: 100vw;
    height: auto;
    @extend %flex;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
        .btn-bar{
            width: 100%;
            height: 30px;
            color: #fff;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            justify-content: space-between;
            .btn{
                width: 50%;
                height: 100%;
                @extend %flex;
                text-align: center;
                background: red;
                &.curry{ background: $curry; }
                &.maho{ background: $maho;}
                &.nabe{ background: $nabe;}
                animation: update 0.4s 1;
                @keyframes update {
                    0%{
                        transform: translateY(100%);
                    }
                    100%{
                        transform: translateY(0%);
                    }
                }
            }
            @media #{$maxL}{
                position: fixed;
                bottom: 0;
                left: 0;
            }
        }
}
.app-bar{
    height: calc(64px - 28px);
    width: calc(100% - 80px);
    padding: 14px 40px;
    padding-bottom: 0;
    background: transparent;
    @extend %flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    @media #{$maxL}{
        padding: 12px 20px;
        padding-bottom: 0;
        width: calc(100% - 40px);
    }
    .logo-wrap{
        height: 100%;
            img{
                width: auto;
                height: 100%;
            }
    }
    .share-bar{
        display: flex;
        flex-flow: row nowrap;
        position: relative;
        justify-content: space-evenly;
        align-items: center;
        span{
            font-family: $Times;
            color: #fff;
            font-size: 18px;
            display: block;
            margin-right: 20px;
            @media #{$maxL}{
                font-size: 1em;
                margin-right: 12px;
            }
        }
        .share{
            display: block;
            position: relative;
            width: 34px;
            height: 34px;
            padding: 12px;
            @media #{$maxL}{
                padding: 4px;
                width: 28px;
                height: 28px;
                margin-right: 10px;
                &:last-child{
                    margin-right: 0;
                }
            }
            svg{
                fill: #fff;
            }
        }
    }
}
</style>